module.exports = __webpack_public_path__ + "img/down5-zh.6e7fef93.png";